
const state = {
    documents: [],
    file: null,
    docLoader: false,
};

export default state;